module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.ba3dcd89.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/Roboto-Regular.woff
// module id = 1832
// module chunks = 0